import { render } from "./HawamPlayer.vue?vue&type=template&id=3fd138a3&scoped=true"
import script from "./HawamPlayer.vue?vue&type=script&lang=js"
export * from "./HawamPlayer.vue?vue&type=script&lang=js"

import "./HawamPlayer.vue?vue&type=style&index=0&id=3fd138a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd138a3"]])

export default __exports__